var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 39.5882L17.6623 45.3174C17.2498 45.5847 16.8185 45.6993 16.3685 45.6611C15.9185 45.6229 15.5248 45.4702 15.1873 45.2028C14.8498 44.9354 14.5873 44.6016 14.3998 44.2013C14.2123 43.8011 14.1748 43.3519 14.2873 42.8538L16.7623 32.0257L8.49351 24.7497C8.11851 24.4059 7.88451 24.014 7.79151 23.574C7.69851 23.134 7.72626 22.7047 7.87476 22.2861C8.02326 21.8675 8.24826 21.5238 8.54976 21.2549C8.85126 20.986 9.26376 20.8141 9.78726 20.7393L20.6998 19.7653L24.9185 9.56738C25.106 9.10905 25.397 8.7653 25.7915 8.53613C26.186 8.30697 26.5888 8.19238 26.9998 8.19238C27.4108 8.19238 27.8135 8.30697 28.208 8.53613C28.6025 8.7653 28.8935 9.10905 29.081 9.56738L33.2998 19.7653L44.2123 20.7393C44.7373 20.8156 45.1498 20.9875 45.4498 21.2549C45.7498 21.5222 45.9748 21.866 46.1248 22.2861C46.2748 22.7063 46.3033 23.1363 46.2103 23.5763C46.1173 24.0163 45.8825 24.4075 45.506 24.7497L37.2373 32.0257L39.7123 42.8538C39.8248 43.3504 39.7873 43.7995 39.5998 44.2013C39.4123 44.6031 39.1498 44.937 38.8123 45.2028C38.4748 45.4686 38.081 45.6214 37.631 45.6611C37.181 45.7009 36.7498 45.5863 36.3373 45.3174L26.9998 39.5882Z",
    fill: "#00E676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.1456a4b33b1fc21ce26f276c610a142a.svg";
export { ForwardRef as ReactComponent };